import { createSlice } from '@reduxjs/toolkit';
import { Notification } from 'components/CustomNotification';
import {
  AddEducation,
  UpdateEducation,
  GetEducationById,
  DeleteEducation,
} from '../services/EducationService';

export const EducationSlice = createSlice({
  name: 'dropdown',
  initialState: {
    addEducation: '',
    EducationList: [],
    getEducation: '',
    updateActivities: '',
  },
  reducers: {
    addEducation: (state, action) => {
      state.addEducation = [action.payload];
    },
    EducationList: (state, action) => {
      state.EducationList = [action.payload];
    },
    getEducation: (state, action) => {
      state.getEducation = [action.payload];
    },
    updateActivities: (state, action) => {
      state.updateActivities = [action.payload];
    },
  },
});

export const InsertEducation = (payload) => async () => {
  return AddEducation(payload);
};

export const updateEducationList = (payload, expid) => async () => {
  return UpdateEducation(payload, expid);
};

export const getEducationByuserId = (data) => async (dispatch) => {
  GetEducationById(data)
    .then((response) => {
      dispatch(getEducation(response.data));
    })
    .catch((err) => {
      Notification('warning', err.response?.data?.message);
    });
};

export const deleteEducation = (data) => async (dispatch) => {
  DeleteEducation(data)
    .then((response) => {
      Notification('success', response?.data?.message);
      dispatch(getEducationByuserId());
    })
    .catch((err) => {
      Notification('warning', err.response?.data?.message);
    });
};

export const { EducationList, addEducation, updateActivities, getEducation } =
  EducationSlice.actions;
export default EducationSlice.reducer;
